import { ctx } from '@/util/context'
import { jsx, type JsxElementProps } from '@amazon/vinyl-tsx'
import { asData, type MaybeObservableValue } from '@amazon/vinyl-observable'
import { loadIcon, type IconName } from './Icons'

const { errorHandler } = ctx('Icon')

export type IconProps = JsxElementProps<'span'> & {
    readonly icon: MaybeObservableValue<IconName>
}

export function Icon(props: IconProps) {
    const { className, ...rest } = props

    const el = <span {...rest} className={'iconContainer ' + (className ?? '')} />

    asData(props.icon).onData((icon) => {
        // Lazily inject the SVG
        loadIcon(icon)
            .then((iconHtml) => {
                el.innerHTML = iconHtml
            })
            .catch(errorHandler)
    })
    return el
}
